import brand from '@helpers/brand';
import { siteWide } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.section `
  --sectionSpacingTop: 40px;
  --sectionSpacingBottom: 40px;
  --bgColour: ${brand.black};

  position: relative;
  scroll-margin: var(--headerHeight) 0 0;
  background-color: var(--bgColour);
  color: ${brand.white};

  &[data-variant='grey'] {
    --bgColour: ${brand.primary.darkGrey};
  }


  @media ${from(Device.Tablet)} {
    --sectionSpacingTop: 80px;
    --sectionSpacingBottom: 80px;
  }

  &[data-allow-scroll-margin='true'] {
    overflow: clip;
  }

  &[data-flush='top'] {
    --sectionSpacingTop: 0;

    @media ${from(Device.Tablet)} {
      --sectionSpacingTop: 0;
    }
  }

  &[data-flush='bottom'] {
    --sectionSpacingBottom: 0;

    @media ${from(Device.Tablet)} {
      --sectionSpacingBottom: 0;
    }
  }

  &[data-flush='both'] {
    --sectionSpacingTop: 0;
    --sectionSpacingBottom: 0;

    @media ${from(Device.Tablet)} {
      --sectionSpacingTop: 0;
      --sectionSpacingBottom: 0;
    }
  }

  /* Negative margin bottom to force overlap */
  &[data-overlap-bottom='true'] {
    margin-bottom: calc(var(--sectionSpacingBottom) * -1);
  }
`;
const Inner = styled.div `
  color: var(--fgColor);
  padding-top: var(--sectionSpacingTop);
  padding-bottom: var(--sectionSpacingBottom);

  /* Don't apply background color for white backgrounds */
  ${Container} & {
    background: var(--bgColor);
  }
`;
const SiteWide = styled.div `
  ${siteWide}
`;
const SectionWrapperStyles = {
    Container,
    Inner,
    SiteWide,
};
export default SectionWrapperStyles;
